export default (set, get, data) => {
  set(
    () => ({
      ...get(),
      cabinetVisualizer: {
        ...get().cabinetVisualizer,
        ...data,
        skuDrawer: {
          ...get().cabinetVisualizer.skuDrawer,
          ...data.skuDrawer
        }
      },
    }),
    false,
    { type: 'cabinetVisualizer/updateCabinetVisualizer', data }
  );
};